/**
 * @author      jose.lucena@zumper.com (José Lucena)
 * @copyright   Copyright (c) 2025, Zumper
 * @description metro rent report modal actions
 */

import type { MetroRentReport } from '@zcode/bizos'
import { createAction } from 'redux-actions'
import { RECEIVE_DATA } from '../constants/metroRentReportModal'

export const receiveData = createAction<MetroRentReport, typeof RECEIVE_DATA>(RECEIVE_DATA)
